import { render, staticRenderFns } from "./OrderInfoComplete.vue?vue&type=template&id=27f95ed0&scoped=true&"
import script from "./OrderInfoComplete.vue?vue&type=script&lang=js&"
export * from "./OrderInfoComplete.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoComplete.vue?vue&type=style&index=0&id=27f95ed0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f95ed0",
  null
  
)

export default component.exports